import { TokenPayload } from "../types";

export const getTokenPayload = (token: string): TokenPayload => {
  const arrayToken = token.split(".");
  const tokenPayload = JSON.parse(atob(arrayToken[1]));
  return tokenPayload;
};
